/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";

// react-router-dom components
import { Link, useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import GoogleIcon from "@mui/icons-material/Google";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpg";
import { toast } from "react-toastify";
import { login, logout } from "../../../actions/authentication/auth";
import { CircularProgress } from "@mui/material";
import {Button} from "@heroui/button";
function Basic() {
  const [rememberMe, setRememberMe] = useState(false);

  const handleSetRememberMe = () => setRememberMe(!rememberMe);
  const router = useNavigate();
  const [loading, setLoading] = useState(false);
  async function logoutUser(){
    const res = await logout();
  }

  useEffect(() => {
    logoutUser();
  }, []);
  async function submitAuth(e) {
    e.preventDefault();

    setLoading(true);
    const formData = new FormData(e.target);
    formData.append("type", "1");

    const auth = await login(formData);
    if (auth.status === "success") {
      router("/");
      toast.success("ورود موفقیت آمیز!");
    } else {
      toast.error(auth.message);
    }
    setLoading(false);
  }
  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1} mb={1}>
            ورود به سیستم
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={submitAuth}>
            <MDBox mb={2}>
              <MDInput
                type="text"
                label="نام کاربری"
                name="username"
                fullWidth
                sx={{
                  "& .MuiInputLabel-root": {
                    whiteSpace: "nowrap",
                    overflow: "visible",
                  },
                }}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="رمزعبور"
                name="password"
                fullWidth
                sx={{
                  "& .MuiInputLabel-root": {
                    whiteSpace: "nowrap",
                    overflow: "visible",
                  },
                }}
              />
            </MDBox>
            <MDBox display="flex" alignItems="center" ml={-1}>
              <Switch checked={rememberMe} onChange={handleSetRememberMe} />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                onClick={handleSetRememberMe}
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;مرا به خاطر بسپار
              </MDTypography>
            </MDBox>
            <MDBox mt={4} mb={1}>
              <Button isLoading={loading} type={"submit"} variant="gradient" className="!bg-blue-500 hover:bg-blue-600 text-white w-full">
                ورود
              </Button>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
